module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Integrante'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "readonly": "",
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.nome),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "nome", $$v)
      },
      expression: "integrante.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vínculo",
      "value": _vm.integrante.vinculo,
      "max-height": "400",
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Função",
      "items": _vm.listaFuncao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.funcao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "funcao", $$v)
      },
      expression: "integrante.funcao"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.integrante.funcao.item !== 1) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Assessor",
      "items": _vm.listaAssessor,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "disabled": _vm.projeto.assessor === true && _vm.administrador === false,
      "autocomplete": ""
    },
    model: {
      value: (_vm.integrante.assessor),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "assessor", $$v)
      },
      expression: "integrante.assessor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.integrante.funcao.item === 1) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Assessor",
      "value": "-",
      "disabled": "",
      "max-height": "400",
      "readonly": ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), (_vm.integrante.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                      O assessor deve ser um único integrante da equipe e terá apenas a permissão de preenchimento, não sendo autorizado a ele submeter para aprovação, excluir ou finalizar a ação.\n                    ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga horária semanal",
      "prepend-icon": "dashboard",
      "rules": _vm.regrasCargaHoraria,
      "disabled": _vm.integrante.funcao.item === 1,
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "cargaHoraria", $$v)
      },
      expression: "integrante.cargaHoraria"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Escolaridade",
      "items": _vm.listaTitulacao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.titulacao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "titulacao", $$v)
      },
      expression: "integrante.titulacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "dataInicial", $$v)
      },
      expression: "integrante.dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.integrante.situacao !== 'A') ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final",
      "clearable": ""
    },
    model: {
      value: (_vm.integrante.dataFinal),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "dataFinal", $$v)
      },
      expression: "integrante.dataFinal"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), ((_vm.integrante.vinculo === 'Externo' || _vm.integrante.vinculo === 'Aluno de pós-graduação')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Instituição que o membro da equipe representa",
      "counter": "100",
      "rules": _vm.regrasInstituicao
    },
    model: {
      value: (_vm.integrante.instituicao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "instituicao", $$v)
      },
      expression: "integrante.instituicao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.integrante.alunoPosUfes === 'N') ? _c('p', {
    staticClass: "mt-1"
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "label": "Observação"
    },
    model: {
      value: (_vm.integrante.obsParticipante),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "obsParticipante", $$v)
      },
      expression: "integrante.obsParticipante"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido || (_vm.integrante.alunoPosUfes === 'N' && _vm.integrante.instituicao === null)
    },
    on: {
      "click": _vm.editarIntegrante
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fffcda6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/integrantes/editar-integrante.vue
// module id = 565
// module chunks = 0